module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', [_c('div', {
    staticClass: "questions"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.questions), function(question, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (question.question_pl || 'Nowe pytanie')),
        "errors": _vm.checkForErrors(_vm.errors.questions, [i]),
        "items": _vm.form.questions,
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "questions", $event)
        }
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Pytanie",
        "error": _vm.errors.questions && _vm.errors.questions[i] && _vm.errors.questions[i]['question']
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea"
      },
      model: {
        value: (question[_vm.addLanguageSuffix('question')]),
        callback: function($$v) {
          _vm.$set(question, _vm.addLanguageSuffix('question'), $$v)
        },
        expression: "question[addLanguageSuffix('question')]"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Odpowiedź",
        "error": _vm.errors.questions && _vm.errors.questions[i] && _vm.errors.questions[i]['answer']
      }
    }, [_c('wyswig-input', {
      model: {
        value: (question[_vm.addLanguageSuffix('answer')]),
        callback: function($$v) {
          _vm.$set(question, _vm.addLanguageSuffix('answer'), $$v)
        },
        expression: "question[addLanguageSuffix('answer')]"
      }
    })], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("Dodaj pytanie")]), _vm._v(" "), (typeof _vm.errors.questions === 'string') ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.questions) + "\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "left-image",
    attrs: {
      "label": "Grafika po lewej stronie",
      "error": _vm.errors.left_image
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.left_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "left_image", $$v)
      },
      expression: "form.left_image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Grafika po prawej stronie",
      "error": _vm.errors.right_image
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.right_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "right_image", $$v)
      },
      expression: "form.right_image"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-978c2220"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/FAQWidget.vue
// module id = 787
// module chunks = 0